module.exports = __webpack_public_path__ + "static/media/health3.60c24c18.svg";